export default __webpack_public_path__ + "media/zurb/img/playground/how-did-we-build-it-icon-4a3690cd327c8f87beb1bcf28c082b4b.svg";